module.exports = __webpack_public_path__ + "static/media/onsen.09e79103.png";